import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import PropTypes from "prop-types";
import { checkIfStoryPublic } from "../../../access-type-utils";
import { StoryElement } from "@quintype/components";
import { RequestSubscription } from "../../pages/subscription-page/request-subscription";
import { SectionName } from "../../atoms/section-tag";
import { Headline } from "../../atoms/headline";
import { Subheadline } from "../../atoms/subheadline";
import { HeroImage } from "../../atoms/hero-image";
import { Authors } from "../../atoms/author";
import { socialShareSupport } from "../../molecules/social-share";
import { isDesktopSizeViewport } from "../../../utils";
import { StoryCard } from "../../molecules/story-card";
import { StoryTags } from "../../atoms/social-tags";
import { SubscriptionCTA } from "../../molecules/subscription-cta";
import { CommentingWidget } from "../../atoms/commenting-widget/commenting-widget";
import { AmazonPolly } from "../../molecules/amazon-polly/amazon-polly";
import StopPress from "../../molecules/stop-press";
import "./video-story.m.css";
import { GiftStoryButton } from "../../molecules/gift-story-button";

const VideoStoryTemplate = props => {
  const [deviceWidth, deviceWidthHandler] = useState("");
  useEffect(() => {
    deviceWidthHandler(!isDesktopSizeViewport() ? "full-width" : "");
  }, []);

  const firstVideo =
    (props.story.cards &&
      props.story.cards
        .reduce((acc, element) => {
          acc = acc.concat(element["story-elements"]);
          return acc;
        }, [])
        .find(
          ({ type, subtype }) => type === "youtube-video" || (type === "jsembed" && subtype === "dailymotion-video")
        )) ||
    {};

  const isStoryPublic = checkIfStoryPublic(props.story);
  const story = isStoryPublic? props.story: props.hasSubscription ? props.story: props.newStory;
  const storyCards = get(story, ["cards"], []);


  const HeaderVideo = props => {
    return (
      <div styleName="header-videos">
        <StoryElement element={firstVideo} key={firstVideo.id} story={story} />
      </div>
    );
  };
  function getStoryCards(cards = [], story, config, hasSubscription) {
    return cards.map((card, index) => {
      const getSubscriptionCTA = get(card, ["metadata", "attributes", "subscriptioncta", 0], "No");
      const getNewsletter = get(card, ["metadata", "attributes", "newsletter", 0], null);
      const getNewsletterStoryCard = () => {
        return getNewsletter ? (
          <div className="newsletter-grid">
            <StoryCard key={index} card={card} story={story} config={config} firstVideoElementID={firstVideoId} />
            <div className="story-card">
              <StopPress planName={getNewsletter} />
            </div>
          </div>
        ) : (
          <StoryCard key={index} card={card} story={story} config={config} firstVideoElementID={firstVideoId} />
        );
      };
      if (getSubscriptionCTA === "Yes") {
        return (
          <React.Fragment>
            {getNewsletterStoryCard()}
            {!hasSubscription ? (
              <div className="story-card">
                <SubscriptionCTA url={story.slug} />{" "}
              </div>
            ) : null}
          </React.Fragment>
        );
      }
      return getNewsletterStoryCard();
    });
  }

  function showStoryCards(storyCards, config, story, hasSubscription) {
    return (
      <>
        {getStoryCards(storyCards, story, config, hasSubscription)}
        <div className="story-tags">
          <StoryTags story={story} />
        </div>
        {!hasSubscription && checkIfStoryPublic(story) && (
          <div className="story-subscription">{<SubscriptionCTA url={story.slug} />}</div>
        )}
        <div className="metype-widget">
          <CommentingWidget story={story} />
        </div>
      </>
    );
  }

  function getIfNoAccess(storyCards, config, story, hasSubscription) {
    const noOfVisibleCards = get(config, ["layout", "no-of-visible-cards-in-a-blocked-story"]);
    const eligibleCards = storyCards.slice(0, noOfVisibleCards);
    return (
      <>
        {getStoryCards(eligibleCards, story, config, hasSubscription)}
        <RequestSubscription url={story.slug} />
      </>
    );
  }

  function getIfHasAccess(storyCards, config, story, hasSubscription) {
    return showStoryCards(storyCards, config, story, hasSubscription);
  }

  function handleAccess(storyCards, config, story, hasSubscription) {
    if (hasSubscription) {
      return getIfHasAccess(storyCards, config, story, hasSubscription);
    }
    return getIfNoAccess(storyCards, config, story, hasSubscription);
  }

  const { id: firstVideoId = -1 } = firstVideo;

  const storyAccessLevel = get(story, ["access"], "");

  return (
    <div styleName="video-story-wrapper">
      <div className={`${deviceWidth}`}>
        {(props.member && props.hasSubscription) || (storyAccessLevel === "public" || storyAccessLevel === null )? (
          <HeaderVideo story={story} />
        ) : (
          <HeroImage story={story} />
        )}
      </div>
      <div styleName="story-heading">
        <div styleName="section">
          <SectionName story={story} />
        </div>
        <Headline story={story} isStoryPage />
        <Subheadline story={story} />
        <div>{isStoryPublic || props.hasSubscription ? <AmazonPolly story={story} /> : null}</div>
        <div>
          <Authors story={story} />
          {!isStoryPublic && props.hasSubscription ? <GiftStoryButton story={story} /> : null}
        </div>
      </div>
      <div styleName="story-content">
        <div styleName="social-share-icons">
          <div styleName="sticky">{socialShareSupport(story)}</div>
        </div>
        <div styleName="story-cards">
          {isStoryPublic
            ? showStoryCards(storyCards, props.config, story, props.hasSubscription)
            : handleAccess(storyCards, props.config, story, props.hasSubscription)}
        </div>
      </div>
    </div>
  );
};

VideoStoryTemplate.propTypes = {
  story: PropTypes.shape({
    cards: PropTypes.array
  }),
  member: PropTypes.object,
  config: PropTypes.object,
  hasSubscription: PropTypes.bool
};

class VideoStoryAccessWrapper extends React.Component {
  render() {
    return (
      <div>
        <VideoStoryTemplate {...this.props} />
      </div>
    );
  }
}

class VideoStoryBase extends React.Component {
  render() {
    return <VideoStoryAccessWrapper {...this.props} />;
  }
}

VideoStoryBase.propTypes = {
  config: PropTypes.object
};

const mapStateToProps = state => ({
  config: get(state, ["qt", "config"], {}),
  member: get(state, ["member"], null),
  hasSubscription: get(state, ["isSubscribedUser", "userHasSubscription"], false)
});

export const VideoStory = connect(mapStateToProps)(VideoStoryBase);
